package waldo.sankan.lineamunicipalkmp.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD

@Composable
fun TipificacionDialog(
    titulo: String,
    catalogoDelitos: List<waldo.sankan.lineamunicipalkmp.model.DelitoTipificado>,
    seleccionActual: List<String>,
    onDismiss: () -> Unit,
    onConfirm: (List<String>) -> Unit
) {
    var seleccionTemporal by remember { mutableStateOf(seleccionActual.toSet()) }
    var familiaSeleccionada by remember { mutableStateOf<String?>(null) }

    // --- CONEXIÓN DINÁMICA AL CATÁLOGO ---
    val familias = remember(catalogoDelitos) {
        catalogoDelitos.map { it.familia.uppercase().trim() }.distinct().sorted()
    }

    val opcionesFiltradas = remember(familiaSeleccionada, catalogoDelitos) {
        if (familiaSeleccionada == null) emptyList<String>()
        else catalogoDelitos.filter { it.familia.uppercase().trim() == familiaSeleccionada }.map { it.nombre }
    }

    // Capa de fondo (Modal Imperial)
    Div({
        style {
            position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
            backgroundColor(rgba(0, 0, 0, 0.6)); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center); property("z-index", "2000")
        }
    }) {
        // Caja de contenido (Diseño Card Blanca de Élite)
        Div({
            style {
                width(700.px); maxHeight(90.vh); backgroundColor(Color.white); borderRadius(16.px)
                padding(32.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                property("box-shadow", "0px 10px 40px rgba(0,0,0,0.4)")
            }
        }) {
            // --- ENCABEZADO ESTILO DOSSIER ---
            Div({
                style {
                    color(Color("#1976D2")); fontWeight("900"); fontSize(14.px)
                    letterSpacing(1.5.px); marginBottom(8.px)
                }
            }) { Text("CLASIFICACIÓN OPERATIVA") }

            H2({ style { marginTop(0.px); marginBottom(24.px); color(Color.black); fontWeight("bold") } }) {
                Text(titulo)
            }

            // --- SECCIÓN 1: CATEGORÍAS (FAMILIAS) ---
            B({ style { fontSize(14.px); color(Color.gray); marginBottom(8.px) } }) {
                Text("1. SELECCIONE CATEGORÍA:")
            }
            Div({
                style {
                    display(DisplayStyle.Flex); flexWrap(FlexWrap.Wrap); gap(8.px)
                    padding(16.px); backgroundColor(Color("#f8f9fa")); borderRadius(12.px)
                    border(1.px, LineStyle.Solid, Color("#dee2e6")); marginBottom(24.px)
                    maxHeight(150.px); overflowY("auto")
                }
            }) {
                familias.forEach { familia ->
                    val esSeleccionada = familia == familiaSeleccionada
                    Div({
                        onClick { familiaSeleccionada = familia }
                        style {
                            padding(8.px, 16.px); borderRadius(25.px); cursor("pointer")
                            backgroundColor(if (esSeleccionada) Color("#1976D2") else Color.white)
                            color(if (esSeleccionada) Color.white else Color.black)
                            border(1.px, LineStyle.Solid, if (esSeleccionada) Color("#1976D2") else Color("#ccc"))
                            fontSize(14.px); fontWeight(if (esSeleccionada) "bold" else "normal")
                            property("transition", "all 0.2s ease")
                            if (!esSeleccionada) {
                                property("box-shadow", "0px 2px 4px rgba(0,0,0,0.05)")
                            }
                        }
                    }) { Text(familia) }
                }
            }

            // --- SECCIÓN 2: OPCIONES DETALLADAS ---
            B({ style { fontSize(14.px); color(Color.gray); marginBottom(8.px) } }) {
                Text("2. DETALLES ESPECÍFICOS:")
            }
            Div({
                style {
                    overflowY("auto"); flexGrow(1); border(1.px, LineStyle.Solid, Color("#eee"))
                    padding(12.px); borderRadius(12.px); backgroundColor(if (familiaSeleccionada == null) Color("#fafafa") else Color.white)
                }
            }) {
                if (familiaSeleccionada == null) {
                    Div({ style { textAlign("center"); padding(40.px); color(Color.lightgray); fontStyle("italic") } }) {
                        Text("<- Seleccione una categoría arriba para ver opciones")
                    }
                } else {
                    opcionesFiltradas.forEach { opcion ->
                        val marcado = opcion in seleccionTemporal
                        Label(attrs = {
                            style {
                                display(DisplayStyle.Flex); alignItems(AlignItems.Center); padding(12.px)
                                borderRadius(8.px); cursor("pointer"); marginBottom(4.px)
                                backgroundColor(if (marcado) rgba(25, 118, 210, 0.08) else Color.transparent)
                                property("transition", "background 0.2s")
                            }
                        }) {
                            Input(type = InputType.Checkbox) {
                                if (marcado) attr("checked", "true")
                                onChange { event ->
                                    val currentSet = seleccionTemporal.toMutableSet()
                                    if (event.value) currentSet.add(opcion) else currentSet.remove(opcion)
                                    seleccionTemporal = currentSet
                                }
                            }
                            Span({
                                style {
                                    marginLeft(16.px); fontSize(16.px)
                                    color(if (marcado) Color("#1976D2") else Color.black)
                                    fontWeight(if (marcado) "bold" else "normal")
                                }
                            }) { Text(opcion) }
                        }
                    }
                }
            }

            // --- PIE DE DIÁLOGO (ACCIONES) ---
            Div({
                style {
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.End)
                    gap(16.px); marginTop(32.px)
                }
            }) {
                Button(attrs = {
                    onClick { onDismiss() }
                    style {
                        color(Color.gray); fontWeight("bold"); fontSize(16.px); cursor("pointer")
                        padding(12.px, 24.px); backgroundColor(Color.transparent); border(0.px)
                    }
                }) { Text("CANCELAR") }

                Button(attrs = {
                    onClick { onConfirm(seleccionTemporal.toList()) }
                    style {
                        padding(12.px, 32.px); fontSize(16.px); fontWeight("bold")
                        backgroundColor(Color("#1976D2")); color(Color.white)
                        border(0.px); borderRadius(8.px); cursor("pointer")
                        property("box-shadow", "0px 4px 12px rgba(25, 118, 210, 0.3)")
                    }
                }) {
                    Text("CONFIRMAR (${seleccionTemporal.size})")
                }
            }
        }
    }
}